var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16ZM16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM13.1695 15.2929C12.779 14.9024 12.1458 14.9024 11.7553 15.2929C11.3648 15.6834 11.3648 16.3166 11.7553 16.7071L14.1604 19.1123C14.551 19.5028 15.1841 19.5028 15.5747 19.1123L20.385 14.302C20.7755 13.9114 20.7755 13.2783 20.385 12.8877C19.9944 12.4972 19.3613 12.4972 18.9707 12.8877L14.8676 16.9909L13.1695 15.2929Z",
    fill: "#D3607D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkFlag);
export default __webpack_public_path__ + "static/media/Ok_flag.ecf2f1b8c5f8d6da3cc2d43e5a9e420e.svg";
export { ForwardRef as ReactComponent };